import { render, staticRenderFns } from "./DaisoResizedImage.vue?vue&type=template&id=0e36aa10&"
import script from "./DaisoResizedImage.vue?vue&type=script&lang=js&"
export * from "./DaisoResizedImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports